import PropTypes from 'prop-types'
import React, { cloneElement } from 'react'

// 子コンポーネントがクリックされたら
// 子コンポーネントの key に指定された値が onSwitch で返ります
// key が指定されていなかった場合は、0から始まる連番の数値が onSwitch で返ります
const ButtonGroup = ({ className, children, selectedKey, onSwitch }) => {
  const elements = children.filter(element => element !== null).map((element, i) => {
    const key = element.key || i
    return cloneElement(element, {
      key: i,
      isSelected: selectedKey === key,
      onClick: () => onSwitch(key)
    })
  })

  return <div className={className}>{elements}</div>
}

ButtonGroup.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  // eslint-disable-next-line react/forbid-prop-types
  selectedKey: PropTypes.any,
  onSwitch: PropTypes.func.isRequired
}

ButtonGroup.defaultProps = {
  className: null,
  children: null,
  selectedKey: null
}

export default ButtonGroup
